import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

type TopbarProps = {
  menuState: boolean;
  openAction: (open: boolean) => void;
};

const BUILD_VERSION = process.env.REACT_APP_VERSION ?? 'dev';
const BUILD_DATE = process.env.REACT_APP_BUILD_DATE ?? '';

const Topbar = (props: TopbarProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuth();
  const isAnalysis = location.pathname.startsWith('/analysis');

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: '#192338' }}>
      <IconButton
        size="large"
        edge="end"
        color="inherit"
        aria-label="menu"
        sx={{ position: 'absolute', left: 0, top: '7px', zIndex: 1, display: { lg: 'none' } }}
        onClick={() => props.openAction(!props.menuState)}
      >
        <MenuIcon />
      </IconButton>

      <Toolbar sx={{ justifyContent: 'center' }}>
        <Box
          component="img"
          sx={{ height: 40, marginRight: 2, cursor: 'pointer' }}
          alt="Bahn Stuttgart Logo"
          src="/logo.png"
          onClick={() => navigate('/live')}
        />
      </Toolbar>

      {/* Analyse nav button */}
      <Box sx={{ position: 'absolute', right: 120, top: '50%', transform: 'translateY(-50%)' }}>
        <Button
          size="small"
          onClick={() => navigate(isAnalysis ? '/live' : '/analysis')}
          sx={{
            color: isAnalysis ? '#f0a500' : 'rgba(255,255,255,0.7)',
            fontSize: '12px',
            textTransform: 'none',
            letterSpacing: '0.05em',
            border: isAnalysis ? '1px solid #f0a500' : '1px solid rgba(255,255,255,0.2)',
            borderRadius: '4px',
            padding: '2px 10px',
            '&:hover': {
              color: '#f0a500',
              borderColor: '#f0a500',
              backgroundColor: 'rgba(240,165,0,0.08)',
            },
          }}
        >
          {isAnalysis ? '← Live' : 'Analyse'}
        </Button>
      </Box>

      {/* User + sign out */}
      <Box sx={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          size="small"
          onClick={handleSignOut}
          sx={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: '11px',
            textTransform: 'none',
            letterSpacing: '0.05em',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '4px',
            padding: '2px 8px',
            minWidth: 0,
            '&:hover': {
              color: '#ff6b6b',
              borderColor: '#ff6b6b',
              backgroundColor: 'rgba(255,107,107,0.08)',
            },
          }}
        >
          Sign out
        </Button>
      </Box>

      <Box sx={{ position: 'absolute', right: 12, bottom: 4, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {user && (
          <Typography sx={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', display: { xs: 'none', md: 'block' } }}>
            {user.email}
          </Typography>
        )}
        <Typography sx={{ fontSize: '10px', color: 'rgba(255,255,255,0.7)', letterSpacing: '0.03em' }}>
          {BUILD_VERSION}{BUILD_DATE ? ` · ${BUILD_DATE}` : ''}
        </Typography>
      </Box>

    </AppBar>
  );
};

export default Topbar;